// src/__internal__/activity/useActivityParams.ts
import { useContext } from "react";
import { ActivityContext } from "./ActivityProvider.mjs";
function useActivityParams() {
  return useContext(ActivityContext).params;
}
export {
  useActivityParams
};
